import { render, staticRenderFns } from "./iconPickups.vue?vue&type=template&id=792d88ec&scoped=true"
import script from "./iconPickups.vue?vue&type=script&lang=js"
export * from "./iconPickups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792d88ec",
  null
  
)

export default component.exports